var exports = {
  "Kk": "InviteEmbed.module__icon___Nk9Fdm",
  "EU": "InviteEmbed.module__iconFallback___Nk9Fdm",
  "C1": "InviteEmbed.module__titleRowWithIcon___Nk9Fdm",
  "gn": "InviteEmbed.module__titleContainer___Nk9Fdm",
  "Qw": "InviteEmbed.module__titleText___Nk9Fdm",
  "fH": "InviteEmbed.module__headerInvite___Nk9Fdm",
  "dT": "InviteEmbed.module__inviteWrapper___Nk9Fdm",
  "M1": "InviteEmbed.module__stats___Nk9Fdm",
  "dJ": "InviteEmbed.module__stat___Nk9Fdm",
  "gW": "InviteEmbed.module__statDot___Nk9Fdm",
  "rR": "InviteEmbed.module__statDotOnline___Nk9Fdm",
  "rb": "InviteEmbed.module__statDotMembers___Nk9Fdm",
  "KA": "InviteEmbed.module__statText___Nk9Fdm",
};

module.exports = exports;
